import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { cn } from '@/lib/cn'

type Variant = 'primary' | 'ghost'

const BASE =
  'inline-flex min-h-11 items-center justify-center gap-2 rounded-full px-6 text-xs font-medium uppercase tracking-[0.18em] transition duration-300 ease-[var(--ease-out-soft)] disabled:cursor-not-allowed disabled:opacity-50'

const VARIANTS: Record<Variant, string> = {
  primary:
    'bg-gold text-ink hover:bg-gold-light hover:shadow-[0_0_32px_-6px_var(--color-gold)] active:scale-[0.98]',
  ghost:
    'border border-gold/35 text-gold hover:border-gold hover:bg-gold/10 active:scale-[0.98]',
}

/** Internal route link styled as a button. */
export function ButtonLink({
  to,
  variant = 'primary',
  className,
  children,
}: {
  to: string
  variant?: Variant
  className?: string
  children: ReactNode
}) {
  return (
    <Link to={to} className={cn(BASE, VARIANTS[variant], className)}>
      {children}
    </Link>
  )
}

export function Button({
  variant = 'primary',
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<'button'> & { variant?: Variant }) {
  return (
    <button className={cn(BASE, VARIANTS[variant], className)} {...props}>
      {children}
    </button>
  )
}
